import React from 'react'
import $ from 'jquery'

import Sectiontitle from './sectionTitle'
import Button from './button'

import '../sass/partials/contact.scss'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/fontawesome-free-solid'

class Contactform extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const $submitBtn = $('.contact__form .btn');
        const emailValidate = (email) => {
            const emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            return emailReg.test( email );
        };

        $submitBtn.on('click', (e) => {
            e.preventDefault();
            
            const $name = $('.name');
            const $email = $('.email');
            const $phone = $('.phoneno');
            const $message = $('.message');

            $name.removeClass('is-err');
            $email.removeClass('is-err');
            $message.removeClass('is-err');
            $('.err-text').html('');
            $submitBtn.addClass('disabled');

            let errors = false;
            if (!$name.val()) {
                $name.addClass('is-err');
                errors = true;
            }

            if (!$email.val()) {
                $email.addClass('is-err');
                errors = true;
            }

            if (!$message.val()) {
                $message.addClass('is-err');
                errors = true;
            }

            if (errors) {
                $('.err-text').html('You have errors. Please check all the required fields.');
                $submitBtn.removeClass('disabled');
                return;
            }

            if (!emailValidate($email.val())) {
                $('.err-text').html('Invalid Email address');
                $submitBtn.removeClass('disabled');
                return;
            }

            const data = {
                name: $name.val(),
                emailId: $email.val(),
                contact: $phone.val(),
                message: $message.val()
            };
            $.post('http://api.akgdynamics.co.uk/revaschildcare/contact_request', data);
            $('.contact__form').addClass('is-submitted');
            setTimeout(() => {
                $('.contact__form').addClass('is-visible');
            }, 10);
        });
    }

    render () {
        return (
            <section className="contact__form">
                <div className="form__data">
                    <Sectiontitle title="Reach out to us" />
                    <div className="rc-copy">
                        Let's get the conversation started, send us your contact details and we'll get back to you.
                    </div>
                    <div className="form">
                        <div>
                            <input className="form-control name" placeholder="Name"/>
                        </div>
                        <div>
                            <input className="form-control email" placeholder="Email Address"/>
                        </div>
                        <div>
                            <input className="form-control phoneno" placeholder="Phone Number (Optional)"/>
                        </div>
                        <div>
                            <textarea className="form-control message" placeholder="Mesage"></textarea>
                        </div>

                        <Button text="Submit" action="true" />
                        <div className="err-text"></div>
                    </div>
                </div>

                <div className="form__success">
                    <FontAwesomeIcon icon={faCheckCircle} />
                    <Sectiontitle title="Thank you for your message" />
                    <div className="rc-copy">
                        We will get back to you as soon as possible.
                    </div>
                </div>
            </section>
        );
    }
}

export default Contactform



// WEBPACK FOOTER //
// ./src/components/contactform.js